import { Phone } from "lucide-react";

const StickyCallButton = () => (
  <a
    href="tel:1300000000"
    className="fixed bottom-4 right-4 z-50 md:hidden bg-[#0066FF] text-white p-4 rounded-full shadow-[0_6px_20px_rgba(0,102,255,0.4)] hover:bg-[#0066FF]/90 transition-colors"
    aria-label="Call Now"
  >
    <Phone className="w-6 h-6" />
  </a>
);

export default StickyCallButton;
